import { createSlice } from "@reduxjs/toolkit";
import { ADD_SERVICE } from "../constants";

export const addServiceSlice = createSlice({
  name: ADD_SERVICE,
  initialState: {},
  reducers: {
    addServiceData: (state, action) => {
      const data = {
        ...state,
        ...action.payload,
      };

      return (state = data);
    },
    removeServiceData: (state, action) => {
      return (state = {});
    },
    clearServiceReduxData: (state, action) => {
      let newData = keyExtractor(action.payload);

      const data = {
        ...state,
        ...newData,
      };
      return data;
    },
  },
});

const keyExtractor = (obj) => {
  let newObj = {};
  Object.keys(obj)?.map((val) => {
    newObj[val] = "";
  });
  return newObj;
};
export const { addServiceData, removeServiceData, clearServiceReduxData } =
  addServiceSlice.actions;

export default addServiceSlice.reducer;
